const required = (value) => {
  // prevent whitespace contributing to valid input
  const inputValue = typeof value === "string" ? value.trim() : value;
  return inputValue ? undefined : "Required";
};

export default required;
